(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-chips"] && !Shopify.designMode) return;
  try {
    /* On a phone the row scrolls sideways, so bring the current chip into view. */
  if (!customElements.get('collection-chips')) {
    customElements.define(
      'collection-chips',
      class extends HTMLElement {
        connectedCallback() {
          const list = this.querySelector('.collection-chips__list');
          const current = this.querySelector('[aria-current="page"]');
          if (!current || list.scrollWidth <= list.clientWidth) return;

          const offset = current.getBoundingClientRect().left - list.getBoundingClientRect().left;
          list.scrollLeft += offset - (list.clientWidth - current.offsetWidth) / 2;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
